module.exports = __webpack_public_path__ + "static/img/customize-btn.3aa1b48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/customize-btn.png
// module id = pEJe
// module chunks = 1